import { makeStyles } from '@material-ui/core';

export const fieldMaxWidth = 50;
export const formStyles = makeStyles(theme => ({
  field: {
    maxWidth: theme.spacing(fieldMaxWidth)
  },
  radio: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1)
  }
}));
